import {get} from '../router/'

export const formConfigurations = {
    addMission: {
        title: "CREATE MISSION",
        fields: [
            {
                type: "text",
                name: "name",
                label: "Name",
                required: true,
                value: "",
                validation: (value) => value.length > 20 ? "This field is a maximum of 20 characters long." : true
            },
            {
                type: "textarea",
                name: "description",
                label: "Description",
                required: true,
                value: "",
                validation: (value) => value.length > 200 ? "This field is a maximum of 200 characters long." : true
            },
            {
                type: "text",
                name: "location",
                label: "Location",
                required: true,
                value: "",
                validation: () => true
            },
            {
                type: "checkbox",
                name: "active_mission",
                label: "The mission is active",
                value: false
            },
            {
                type: "checkbox",
                name: "public_mission",
                label: "The mission is public",
                value: false
            }
        ]
    },
    editMission: (data) => ({
        title: "EDIT MISSION",
        fields: [
            {
                type: "text",
                name: "name",
                label: "Name",
                required: true,
                value: data.name,
                validation: (value) => value.length > 20 ? "This field is a maximum of 20 characters long." : true
            },
            {
                type: "textarea",
                name: "description",
                label: "Description",
                required: true,
                value: data.description,
                validation: (value) => value.length > 200 ? "This field is a maximum of 200 characters long." : true
            },
            {
                type: "text",
                name: "location",
                label: "Location",
                required: true,
                value: data.location,
                validation: (value) => value.length > 20 ? "This field is a maximum of 20 characters long." : true
            },
            {
                type: "checkbox",
                name: "active_mission",
                label: "The mission is active",
                value: data.active_mission === 1
            },
            {
                type: "checkbox",
                name: "public_mission",
                label: "The mission is public",
                value: data.is_public === 1
            }
        ]
    }),
    addMissionVehicle: {
        title: "ASSIGN VEHICLE",
        fields: [
            {
                type: "select",
                name: "vehicle",
                label: "Vehicle",
                required: true,
                value: 0,
                options: [],
                placeholder: 'Select a vehicle'
            }
        ]
    },
    addPerms: {
        title: "ASSIGN PERMISSION",
        fields: [
            {
                type: "select",
                name: "id",
                label: "Permiso",
                required: true,
                value: 0,
                options: [],
                placeholder: 'Selecciona un permiso'
            }
        ]
    },
    addVehicleMission: {
        title: "ASSIGN MISSION",
        fields: [
            {
                type: "select",
                name: "mission",
                label: "Mission",
                required: true,
                value: 0,
                options: [],
                placeholder: 'Select a mission'
            }
        ]
    },
    addVehicle: {
        title: "CREATE VEHICLE",
        fields: [
            {
                type: "text",
                name: "name",
                label: "Name",
                required: true,
                value: "",
                validation: (value) => value.length > 20 ? "This field is a maximum of 20 characters long." : true
            },
            {
                type: "color",
                name: "boat_mark_color",
                label: "Mark color",
                required: false,
                value: "#002885"
            },
            {
                type: "color",
                name: "boat_waypoint_color",
                label: "Waypoint color",
                required: false,
                value: "#002885"
            },
            {
                type: "mac",
                name: "mac",
                label: "Vehicle address",
                hint: "This address is what the vehicle must use to send telemetry",
                required: true,
                value: "",
                validation: (value) => value.length > 20 ? "This field is a maximum of 20 characters long." : true
            }
        ]
    },
    editVehicle: (data) => ({
        title: "EDIT VEHICLE",
        fields: [
            {
                type: "text",
                name: "name",
                label: "Name",
                required: true,
                value: data.name,
                validation: (value) => value.length > 20 ? "This field is a maximum of 20 characters long." : true
            },
            {
                type: "color",
                name: "boat_mark_color",
                label: "Mark color",
                required: false,
                value: data.boat_mark_color || "#002885"
            },
            {
                type: "color",
                name: "boat_waypoint_color",
                label: "Waypoint color",
                required: false,
                value: data.boat_waypoint_color || "#002885"
            },
            {
                type: "mac",
                name: "mac",
                label: "Vehicle address",
                hint: "This address is what the vehicle must use to send telemetry",
                required: true,
                value: data.mac,
                validation: (value) => value.length > 20 ? "This field is a maximum of 20 characters long." : true
            }
        ]
    }),
    addUser:  {
        title: "ADD USER",
        fields: [
            {
                type: "text",
                name: "name",
                label: "Name",
                required: false,
                value: '',
                validation: [(value) => value ? true : "This field is required."]
            },
            {
                type: "text",
                name: "email",
                label: "Email",
                required: false,
                value: '',
                validation: [(value) => /^\S+@\S+\.\S+$/.test(value) ? true : "This field must contain a valid email address"]
            },
            {
                type: "password",
                name: "password",
                label: "Password",
                required: false,
                value: '',
                validation: [(value) => value.length >= 6 ? true : "This field is at least 6 characters long."]
            },
            {
                type: "select",
                name: "role_id",
                label: "Rol",
                required: true,
                value: '',
                validation: [(value) => value ? true : "This field is required."],
                options: [],
                placeholder: 'Selecciona un rol'
            }
        ]
    },
    editUser: (data) => (
        axios.get(`${store.api_url}/admin/role/getAll`)
        .then(response => {
            this.formData[0].fields[3].options = response.data.data
        }).catch(e => {
            console.log(e);
        }),
        {
        title: "EDIT USER",
        fields: [
            {
                type: "text",
                name: "name",
                label: "Name",
                required: true,
                value: data?.name || "",
                validation: [(value) => value ? true : "This field is required."]
            },
            {
                type: "text",
                name: "email",
                label: "Email",
                required: true,
                value: data?.email || "",
                validation: [(value) => /^\S+@\S+\.\S+$/.test(value) ? true : "This field must contain a valid email address"]
            },
            {
                type: "select",
                name: "role_id",
                label: "Rol",
                required: true,
                value: data.role_id,
                validation: [(value) => value ? true : "This field is required."],
                options: get(id) ,
                placeholder: 'Selecciona un rol'
            }
        ]
    }),
    addRole: {
        title: "AÑADIR ROL",
        fields: [
            {
                type: "text",
                name: "display_name",
                label: "Name de muestra",
                required: true,
                value: '',
                validation: (value) => value.length > 20 ? "This field is a maximum of 20 characters long." : true
            }
        ]
    },
    editRole: (data) => ({
        title: "EDITAR ROL",
        fields: [
            {
                type: "text",
                name: "display_name",
                label: "Name de muestra",
                required: true,
                value: data.display_name,
                validation: (value) => value.length > 20 ? "This field is a maximum of 20 characters long." : true
            }
        ]
    })
};


